import React from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';

// Component used to display adds in the home page

const AddsCard = ({ image_link, add_link, title, content }) => {
  return (
    <a href={add_link} style={{ textDecoration: "none", color: "inherit" }}>
      <Card className="mb-3" style={{backgroundColor:"#f8fafd", borderRadius:"0"}}>
        <Card.Body>
          {/* Image + Text Layout */}
          <Row className="align-items-center">
            <Col xs={3} className="text-center">
              <img
                src={image_link}
                alt={title}
                className="img-fluid"
                style={{ width: '100%', height:"100%", border: "1px solid #d9d9d9", padding: "5px", backgroundColor: "white"}}
              />
            </Col>
            <Col>
              <p className="text fw-bold mb-1" style={{color : "#9416b2"}}>{title}</p>
              <p className="text small mb-2" style={{color : "#808080"}}>{content}</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </a>
  );
};

export default AddsCard;
